var subscribe = require('../api/subscribe')
var unsubscribe = require('../api/unsubscribe')
var getUA = require('../../common/get-ua')
var mixin = require('../../common/mixin')
var noop = function () {}
var getNetworkType = require('../api/get-network')
var share = require('../api/share')
var qs = require('querystring')
var isWebProtocal = require('../../common/web-protocol')
var picConverter = require('../../common/picConverter');
var semver = require('../../common/semver');

var qparams = require('../../common/qparams')(location.href);

function prependBizName (key, fail) {
  var bizName = this.getBizName()
	if (key.indexOf(':') > -1) return key
	if (bizName) return bizName + ':' + key
	this.log('bizname not configed')
	fail('bizname not config, please call KNB.confg({bizName: YOUR_BIZ_NAME})')
}

function getWebviewURI() {
  return window.TITANS_WEB_VIEW_URI || 'dianping://web'
}

module.exports = [
  {
    message: 'checkVersion'
  },{
    message: 'getApisVersion',
    handler: function(ref) {
      var success = ref.success; if ( success === void 0 ) success = noop;
      var apis = ref.apis; if ( apis === void 0 ) apis = [];
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      this.checkVersion({
        apis: apis,
        success: function (data) {
          var infos = data['infos'] || data['data']['infos'] || {}; // 容错
          success(apis.map(function (api) {
            return String(infos[api]);
          }));
        },
        fail: fail
      });
    }
  },{
    message: 'actionSheet'
  }, {
    message: 'alert'
  }, {
    name: 'closeWebview',
    message: 'closeWindow'
  }, {
    message: 'getContactList'
  }, {
    name: 'getUA',
    handler: getUA
  }, {
    message: 'confirm'
  }, {
    message: 'getVersion'
  }, {
    message: 'isInstalledApp'
  }, {
    message: 'pickContact'
  }, {
    message: 'prompt'
  }, {
    message: 'publish',
    mapper: function (ref) {
      var type = ref.type;
      var action = ref.action;
      var success = ref.success; if ( success === void 0 ) success = noop;
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;
      var data = ref.data;
      var info = ref.info;

      //fix mtnb 实现bug(for attribute data && info);
      if (type === 'native') return {action: action, success: success, fail: fail, data: info || data}
      var actionName = prependBizName.call(this, action, fail)
      if (actionName) return {action: actionName, success: success, fail: fail, data: info || data}
    }
  }, {
    message: 'remove',
    mapper: function (ref) {
      var type = ref.type;
      var key = ref.key;
      var success = ref.success; if ( success === void 0 ) success = noop;
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      if (type === 'native') return {key: key, success: success, fail: fail}
      var newkey = prependBizName.call(this, key, fail)
      if (newkey) return {key: newkey, success: success, fail: fail}
    }
  }, {
    message: 'retrieve',
    mapper: function (ref) {
      var type = ref.type;
      var key = ref.key;
      var success = ref.success; if ( success === void 0 ) success = noop;
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      if (type === 'native') return {key: key, success: success, fail: fail}
      var newkey = prependBizName.call(this, key, fail)
      if (newkey) return {key: newkey, success: success, fail: fail}
    }
  }, {
    message: 'store',
    mapper: function (ref) {
      var type = ref.type;
      var key = ref.key;
      var value = ref.value;
      var success = ref.success; if ( success === void 0 ) success = noop;
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      if (type === 'native') return {key: key, value: value, success: success, fail: fail}
      var newkey = prependBizName.call(this, key, fail)
      if (newkey) return {key: newkey, value: value, success: success, fail: fail}
    }
  }, {
    message: 'setLLButton'
  }, {
    message: 'setLRButton'
  }, {
    message: 'setRLButton'
  }, {
    message: 'setRRButton'
  }, {
    message: 'setTitle'
  }, {
    message: 'sendSMS'
  }, {
    message: 'setBackgroundColor'
  }, {
    message: 'setNavigationBarHidden',
    os: 'android'
  }, {
    message: 'setBouncesEnabled',
    os: 'ios'
  }, {
    message: 'setScrollEnabled',
    os: 'ios'
  }, {
    message: 'setStatusBarStyle',
    os: 'ios',
    mapper: function (_opts) {
      var opts = mixin({}, _opts)
      if (opts.style === undefined) opts.style = 0
      return opts
    }
  },
  {
    name: 'setNavButtons',
    handler: function (opts) {
      var this$1 = this;

      [].concat(opts).forEach(function (btnConfig) {
        var nobj = mixin({}, btnConfig) // create a copy
        delete nobj.position
        nobj.icon = btnConfig.type === 'base64' ? (btnConfig.icon || '').split('data:image/png;base64,')[1] : nobj.icon
        this$1['set' + btnConfig.position + 'Button'](nobj)
      })
    }
  },
  {
    message: 'bind'
  },
  {
    message: 'chooseImage',
    mapper: function (opts) {
      if (!opts.quality) {
        opts.quality = 50;
      }
      return opts;
    }
  },
  {
    message: 'downloadImage'
  },
  {
    name: 'getCity',
    message: 'getCityInfo'
  },
  {
    message: 'getUserInfo',
    mapper: function (opt) {
      return mixin({}, opt, {
        success: function (result) { return opt.success(mixin(result, {
          token: result.token || result.userToken,
          uuid: result.uuid || qparams.uuid
        })); }
      });
    }
  },
  {
    message: 'getFingerprint'
  },
  {
    message: 'getLocation',
    mapper: function (opts) {
      if (!opts.timeout) {
        opts.timeout = 6000;
      }
      return opts;
    }
  }, {
    // @deprecated
    name: 'getLocationCity',
    message: 'getCityInfo',
    mapper: function (opt) {
      return mixin({}, opt, {
        success: function (cityInfo) { return opt.success(mixin(cityInfo, {cityId: cityInfo.locCityId})); }
      });
    }
  }, {
    // @dp
    message: 'getFingerprint',
    name: 'getCX'
  }, {
    message: 'analyticsTag',
    version: '8.1.6'
  },
  {
    name: 'jumpWebview',
    message: 'jumpToScheme',
    mapper: function (opts) {
      if (isWebProtocal(opts.url)) {
        return mixin({}, opts, {
          url: getWebviewURI() + '?' + qs.stringify(mixin({url: opts.url}, opts.qs))
        });
      }

      return opts;
    }
  },
  {
    name: 'openWebview',
    message: 'openScheme',
    mapper: function (opts) {
      if (isWebProtocal(opts.url)) {
        return mixin({}, opts, {
          url: getWebviewURI() + '?' + qs.stringify(mixin({url: opts.url}, opts.qs))
        });
      }

      return opts;
    }
  },
  {
    name: 'configShare',
    handler: function (opts) {
      var this$1 = this;

      opts = mixin({}, opts)
      var handle = opts.handle || noop
      delete opts.handle
      this.setRRButton({
        icon: 'H5_Share',
        handle: function () {
          handle()
          this$1.share(opts)
        }
      })
    }
  },
  {
    message: 'pickCity'
  },
  {
    message: 'analyticsTag'
  },
  {
    message: 'setBarrageEnabled'
  },
  {
    message: 'getHealthData',
    os: 'ios',
    mapper: function (_opts) {
      if (!_opts) return
      var opts = mixin({}, _opts)
      // 目前支持的类型
      var typeList = [1]
      var type = opts.quantityType
      var fail = opts.fail || noop

      var start = +new Date(opts.startDate)
      var end = +new Date(opts.endDate || new Date())
      if (start > end) { fail('date error'); return; }
      if (typeList.indexOf(type) === -1) { fail('type error'); return; }
      // 单位：秒
      opts.startDate = Math.round(start / 1000)
      opts.endDate = Math.round(end / 1000)
      return opts
    }
  },
  {
    message: 'mapi',
    name: 'ajax',
    mapper: function (_opts) {
      var opts = mixin({}, _opts)
      var self = this;
      opts = this.util.sanitizeAjaxOpts(opts)
      var success = opts.success || noop;
      opts.success = function (ret) {
        var result = JSON.parse(ret.mapiResult)
        result = self.util.transModel(opts.keys, result)
        success(result)
      };
      return opts
    }
  },
  {
    message: 'login',
    mapper: function (opts) {
      var success = opts.success || noop
      // 新版Titans增加type字段标识用户类型
      return mixin({}, opts, {
        success: function (res) {
          success(mixin({}, res, res.dpid ? {type: 'dp'} : {}, {token: res.token || res.userToken}))
        }
      })
    }
  },
  {
    message: 'logout'
  },
  {
    message: 'pay'
  },
  {
    message: 'playVoice'
  },
  {
    message: 'previewImage'
  },
  {
    message: 'setPullDown'
  },
  {
    message: 'stopPullDown'
  },
  {
    message: 'setNavigationBarHidden',
    os: 'ios'
  },
  {
    message: 'uploadPhoto',
    name: 'uploadImage',
    mapper: function (_opts) {
      var opts = mixin({}, _opts);
      var success = opts.success || noop;

      if (!opts.bucket) {
        opts.bucket = opts.clientId = 'knb';
      } else if (!opts.clientId) {
        opts.clientId = opts.bucket;
      }

      opts.success = function (result) {
        result.photoInfos = (result.photoInfos || result.ret || []).map(function (photo) {
          var picKey = picConverter(photo.picKey);
          var picUrl = picConverter(photo.picUrl);
          return mixin({}, photo, {
            picKey: picUrl,
            originalKey: photo.picKey,

            //对齐点评picKey和picUrl的语义
            picUrl: picUrl || (/^https?:\/\//.test(picKey) ? picKey : null),
            originalUrl: photo.picKey || photo.picUrl
          })
        });
        success(result);
      }

      return opts;
    }
  },
  {
    message: 'vibrate'
  },
  {
    message: 'toast'
  },
  {
    message: 'autoLock'
  },
  {
    message: 'lxlog'
  },
  {
    message: 'Semver',
    statics: semver
  },
  {
    message: 'checkAuthorization'
  },
  {
    message: 'capture'
  },
  {
    message: 'shareImage',
    statics: {
      WECHAT_FRIENDS: 0,
      WECHAT_TIMELINE: 1
    }
  },
  {
    message: 'setSearchBar'
  },
  {
    message: 'scanQRCode'
  },
  {
    message: 'setResult',
    statics: {
      "RESULT_OK": -1,
      "RESULT_CANCELED": 0
    }
  },
  {
    //mt 8.5
    message: 'getResult',
    mapper: function(opts){
      var originSuccess = opts.success || noop;
      return mixin({}, opts, {
        success: function (res) {
          originSuccess(mixin({}, {
            resultData: res.resp ? res.resp.resultData : res.resultData,
            resultCode: res.resp ? res.resp.resultCode : res.resultCode
          }));
        }
      }) 
    }
  },
  { 
    //mt 8.5
    message: 'setImageTitle'
  },
  {
    message: 'shark'
  },
  {
    message: 'chooseMedia',
  },
  {
    message: 'playMedia'
  },
  {
    message: 'editMedia'
  },
  {
    message: 'uploadMedia'
  },
  {
    message: 'getDeviceInfo'
  },
  {
    message: 'showKeyboard',
    os: 'android'
  },
  {
    message: 'sendLog',
    mapper: function(opts){
      return mixin({}, opts, {
        time: +new Date(),
        page: location.href
      });
    }
  },
  {
    message: 'shareMiniProgram'
  },
  {
    message: 'addRequestSignature',
    mapper: function(ref){
      var method = ref.method;
      var url = ref.url;
      var body = ref.body; if ( body === void 0 ) body = "";
      var header = ref.header; if ( header === void 0 ) header = {};
      var success = ref.success; if ( success === void 0 ) success = noop;
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      var contentType = header.contentType; if ( contentType === void 0 ) contentType = "";
      var contentEncoding = header.contentEncoding; if ( contentEncoding === void 0 ) contentEncoding = "";
      var originSuccess = success;
      var userAgent = navigator.userAgent || "";
      return {
        method: method, 
        url: url, 
        body: body, 
        header:{contentType: contentType, userAgent: userAgent, contentEncoding: contentEncoding},
        success: function (res) {
          var url = res.url || '';
          if(url.indexOf('://') === -1){
            res.url = decodeURIComponent(url);
          }
          originSuccess(res);
        }, 
        fail: fail
      };
    }
  },
  {
    message: 'stopLocating'
  }

].concat([subscribe, unsubscribe, getNetworkType, share])



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/titans/business/base.js
// module id = 347
// module chunks = 1 12 14